import { render, staticRenderFns } from "./RequestDetails.vue?vue&type=template&id=56954760&scoped=true&"
import script from "./RequestDetails.vue?vue&type=script&lang=js&"
export * from "./RequestDetails.vue?vue&type=script&lang=js&"
import style0 from "./RequestDetails.vue?vue&type=style&index=0&id=56954760&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56954760",
  null
  
)

export default component.exports